import { type StoryblokProductSearchFilterNowType } from '../../../../storyblok'
import { type StoryblokProductSearchFiltersType } from '../StoryblokProductSearchFilters.types'

import { storyblokProductSearchFiltersGetValuesFromString } from './storyblokProductSearchFiltersGetValuesFromString'

export const storyblokProductSearchFiltersGetNow = (
  nowFilters: StoryblokProductSearchFilterNowType,
): Partial<
  Pick<StoryblokProductSearchFiltersType, 'categoryCodes' | 'nowProductGroup'>
> => {
  return {
    categoryCodes: storyblokProductSearchFiltersGetValuesFromString(
      nowFilters.categoryIds,
    ),
    nowProductGroup: ['sameday_nextday'],
  }
}
